/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Needed for quick add */
function serialize(form) {
	var resultArray = new URLSearchParams(Array.from(new FormData(form)))
		.toString()
		.split("&");
	var result = {};
	resultArray.forEach(function (item) {
		var pair = item.split("=");
		result[pair[0]] = pair[1];
	});
	return result;
}

/* Quick add */
document.querySelectorAll(".quickAddForm").forEach(function (formElement) {
	formElement.addEventListener("submit", function (event) {
		try {
			event.preventDefault();
			var serialized = serialize(formElement);

			var addToCartButton = formElement.querySelector(
				".ProductForm__AddToCart"
			); // First, we switch the status of the button
			addToCartButton.setAttribute("disabled", "disabled");
			document.dispatchEvent(new CustomEvent("theme:loading:start")); // Then we add the product in Ajax
			fetch("".concat(window.routes.cartAddUrl, ".js"), {
				body: JSON.stringify(serialize(formElement)),
				credentials: "same-origin",
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
				},
			}).then(function (response) {
				document.dispatchEvent(new CustomEvent("theme:loading:end"));
				var quantityElement = formElement.querySelector('[name="quantity"]');

				if (response.ok) {
					addToCartButton.removeAttribute("disabled"); // We simply trigger an event so the mini-cart can re-render
					document.documentElement.dispatchEvent(
						new CustomEvent("product:added", {
							bubbles: true,
							detail: {
								quantity: serialized.quantity,
								variant: serialized.id,
							},
						})
					);
				} else {
					response.json().then(function (content) {
						var errorMessageElement = document.createElement("span");
						errorMessageElement.className =
							"ProductForm__Error Alert Alert--error";
						errorMessageElement.innerHTML = content["description"];
						addToCartButton.removeAttribute("disabled");
						addToCartButton.insertAdjacentElement(
							"afterend",
							errorMessageElement
						);
						setTimeout(function () {
							errorMessageElement.remove();
						}, 2500);
					});
				}
			});
		} catch (e) {
			console.error("QuickAdd Error", e.message);
		}
	});
});

/* Yotpo translation hack */
setTimeout(function () {
	if (document.querySelectorAll(".yotpo-icon-button-text")) {
		document
			.querySelectorAll(".yotpo-icon-button-text")
			.forEach((b) => (b.innerHTML = window.strings.yotpo.button_text));
		document
			.querySelectorAll(".write-first-review-button")
			.forEach((b) => (b.innerHTML = window.strings.yotpo.first_review_button));
	}
}, 2000);

/* Code quiz translation hack — on French pages, swap EN quiz anchors (#finder-quiz-XXXX)
   to their FR equivalent. Runs ASAP (not on a 2s delay, which let clicks through before the
   swap) AND again at click time, so the quiz app never receives the EN id. */
(function () {
	function isFrench() {
		// content_for_header is deferred via setbg.liquid, so window.Shopify may be undefined/late;
		// fall back to <html lang> (= request.locale.iso_code) and prefix-match "fr" (handles fr-CA).
		var s = (window.Shopify && window.Shopify.locale ? window.Shopify.locale : "").toLowerCase();
		var h = (document.documentElement.lang || "").toLowerCase();
		return s.indexOf("fr") === 0 || h.indexOf("fr") === 0;
	}
	// Links can be bare anchors ("#finder-quiz-7120") OR full menu URLs, which Shopify renders
	// as "/fr/products/code#finder-quiz-7120" — so match on the trailing anchor and swap only it,
	// keeping the path. (An exact href match never hits menu links.)
	function frHref(href) {
		if (!href) return null;
		var list = window.quizTranslations || [];
		for (var i = 0; i < list.length; i++) {
			var t = list[i];
			if (t.en && t.fr && href.slice(-t.en.length) === t.en) {
				return href.slice(0, href.length - t.en.length) + t.fr;
			}
		}
		return null;
	}
	function swapAll() {
		if (!isFrench()) return;
		(window.quizTranslations || []).forEach(function (t) {
			if (!t.en || !t.fr) return;
			document.querySelectorAll('a[href$="' + t.en + '"]').forEach(function (a) {
				var fr = frHref(a.getAttribute("href"));
				if (fr) a.setAttribute("href", fr);
			});
		});
	}
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", swapAll);
	} else {
		swapAll();
	}
	// Safety net: rewrite at click time (capture phase) for links added after load, or clicked early.
	document.addEventListener("click", function (e) {
		if (!isFrench() || !e.target || !e.target.closest) return;
		var a = e.target.closest("a[href]");
		if (!a) return;
		var fr = frHref(a.getAttribute("href"));
		if (fr) a.setAttribute("href", fr);
	}, true);
})();

// Access the first element with the class 'pro_product'
var productSelect = document.getElementsByClassName("pro_product")[0];

if (productSelect) {
	productSelect.addEventListener("change", function () {
		var selectedValue = this.value;

		// Find all .variant_meta elements
		var variantMetaElements = document.querySelectorAll(".variant_meta");

		// Iterate through each .variant_meta element
		variantMetaElements.forEach(function (variantMeta) {
			var variantMetaId = variantMeta.getAttribute("data-id");

			// Check if the data-id matches the selected value
			if (variantMetaId === selectedValue) {
				// Add the display_display class
				variantMeta.classList.add("display_display");
			} else {
				// Optionally, remove the class if it does not match
				variantMeta.classList.remove("display_display");
			}
		});
	});
} else {
	console.log("No element with class pro_product found.");
}

// onload main code

window.addEventListener("load", function () {
	const targetId = "39623639859235";

	const variantMetaElements = document.querySelectorAll(
		".metafield .variant_meta"
	);

	variantMetaElements.forEach(function (element) {
		const dataId = element.getAttribute("data-id");

		if (dataId === targetId) {
			element.classList.add("display_display");
			console.log("Match found and class added:", dataId);
		}
	});
});

// Sticky-ATC visibility handler
window.addEventListener("DOMContentLoaded", (event) => {
	const stickyATC = document.querySelector("#sticky-atc");
	const upperLimit = document.querySelector("#product-info");
	const lowerLimit = document.querySelector("#section-footer");
	const btn = stickyATC.querySelector('[name="add"]');

	// Add scroll handler with proper calculations
	window.addEventListener("scroll", () => {
		// Get the current scroll position and viewport height
		const scrollPosition = window.pageYOffset;
		const viewportHeight = window.innerHeight;

		// Calculate thresholds with buffers
		const startThreshold =
			upperLimit.getBoundingClientRect().top + window.pageYOffset + 800;
		const endThreshold =
			lowerLimit.getBoundingClientRect().top +
			window.pageYOffset -
			viewportHeight +
			200;

		if (scrollPosition > startThreshold && scrollPosition < endThreshold) {
			stickyATC.classList.add("show");
			document.documentElement.style.paddingBottom = `${stickyATC.clientHeight}px`;
		} else {
			stickyATC.classList.remove("show");
			document.documentElement.style.paddingBottom = "0";
		}
	});

	// Trigger initial check
	window.dispatchEvent(new Event("scroll"));
});

//sticky-ATC form handler
document.addEventListener("DOMContentLoaded", function () {
	let stickyButton = document.querySelector(".js-sticky-atc");
	let mainForm = document.querySelector("form.ProductForm");
	let mainSubmit = mainForm ? mainForm.querySelector('[type="submit"]') : null;
	let stickyPrice = document.querySelector(".sticky-price");

	// Sticky button submits the main form
	if (stickyButton && mainForm && mainSubmit) {
		stickyButton.addEventListener("click", function (e) {
			e.preventDefault();
			if (!mainSubmit.disabled) {
				mainSubmit.click();
			}
		});
	}

	// Sync sticky button state/price with main form on variant change
	document.addEventListener("variant:changed", function (event) {
		let variant = event.detail && event.detail.variant;
		if (!variant) return;
		// Update price
		if (stickyPrice) {
			if (window.Currency && window.Currency.formatMoney) {
				stickyPrice.innerHTML = window.Currency.formatMoney(
					variant.price,
					window.theme.moneyFormat
				);
			} else {
				stickyPrice.innerHTML = (variant.price / 100).toLocaleString(
					undefined,
					{ style: "currency", currency: "{{ shop.currency }}" }
				);
			}
		}
		// Update button state
		if (variant.available) {
			stickyButton.removeAttribute("disabled");
			stickyButton.innerHTML = `
				<span>${variant.preorder ? '{{ "product.form.pre_order" | t }}' : '{{ "product.form.add_to_cart" | t }}'}</span>
				<span class="Button__SeparatorDot"></span>
				<span class="sticky-price">${stickyPrice ? stickyPrice.innerHTML : ""}</span>
			`;
		} else {
			stickyButton.setAttribute("disabled", "disabled");
			stickyButton.innerHTML = `{{ 'product.form.sold_out' | t }}`;
		}
	});

	let stickyQty = document.querySelector('#sticky-atc [name="quantity"]');
	let mainQty = mainForm ? mainForm.querySelector('[name="quantity"]') : null;
	if (stickyQty && mainQty) {
		stickyQty.addEventListener("input", function () {
			mainQty.value = stickyQty.value;
		});
		mainQty.addEventListener("input", function () {
			stickyQty.value = mainQty.value;
		});
	}
});


/* noopener handler for external links obelli v1.4 Feb2026 sprint */
document.addEventListener('DOMContentLoaded', () => {
	const externalLinks = document.querySelectorAll('a[target="_blank"]')

	externalLinks.forEach(link => {
		const existingRel = link.getAttribute('rel') || ''
		if (!existingRel.includes('noopener')) {
			link.setAttribute('rel', existingRel ? `${existingRel} noopener` : 'noopener')
		}
	})
})